"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateRouteAuthenticationStarted = exports.validateRouteAuthenticationCompleted = exports.validateRouteAuthentication = exports.rehydrateSessionStarted = exports.rehydrateSessionCompleted = exports.rehydrateSession = exports.logoutAndRedirectStarted = exports.logoutAndRedirectCompleted = exports.logoutAndRedirect = exports.impersonateRedirectStarted = exports.impersonateRedirectCompleted = exports.impersonateAgentRedirect = exports.fetchSSOSessionSucceeded = exports.fetchSSOSessionStarted = exports.fetchSSOSessionFailed = exports.fetchSSOSession = exports.changeAgencyViewStarted = exports.changeAgencyViewCompleted = exports.changeAgencyView = exports.agentUnauthorizedAndRedirectStarted = exports.agentUnauthorizedAndRedirectCompleted = exports.agentUnauthorizedAndRedirect = exports.VALIDATE_ROUTE_AUTHENTICATION_STARTED = exports.VALIDATE_ROUTE_AUTHENTICATION_COMPLETED = exports.REHYDRATE_SESSION_STARTED = exports.REHYDRATE_SESSION_COMPLETED = exports.OIDC_USER_EXPIRING = exports.OIDC_USER_EXPIRED = exports.LOGOUT_REDIRECT_STARTED = exports.LOGOUT_REDIRECT_COMPLETED = exports.IMPERSONATE_REDIRECT_STARTED = exports.IMPERSONATE_REDIRECT_COMPLETED = exports.FETCH_SSO_SESSION_SUCCEEDED = exports.FETCH_SSO_SESSION_STARTED = exports.FETCH_SSO_SESSION_FAILED = exports.CHANGE_AGENCY_VIEW_STARTED = exports.CHANGE_AGENCY_VIEW_COMPLETED = exports.AGENT_UNAUTHORIZED_AND_REDIRECT_STARTED = exports.AGENT_UNAUTHORIZED_AND_REDIRECT_COMPLETED = void 0;
var ssoService = _interopRequireWildcard(require("../services/ssoService"));
var _ = require("../");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var OIDC_USER_EXPIRED = exports.OIDC_USER_EXPIRED = "redux-oidc/USER_EXPIRED";
var OIDC_USER_EXPIRING = exports.OIDC_USER_EXPIRING = "redux-oidc/USER_EXPIRING";
var FETCH_SSO_SESSION_STARTED = exports.FETCH_SSO_SESSION_STARTED = "FETCH_SSO_SESSION_STARTED";
var FETCH_SSO_SESSION_SUCCEEDED = exports.FETCH_SSO_SESSION_SUCCEEDED = "FETCH_SSO_SESSION_SUCCEEDED";
var FETCH_SSO_SESSION_FAILED = exports.FETCH_SSO_SESSION_FAILED = "FETCH_SSO_SESSION_FAILED";
var LOGOUT_REDIRECT_STARTED = exports.LOGOUT_REDIRECT_STARTED = "LOGOUT_REDIRECT_STARTED";
var LOGOUT_REDIRECT_COMPLETED = exports.LOGOUT_REDIRECT_COMPLETED = "LOGOUT_REDIRECT_COMPLETED";
var VALIDATE_ROUTE_AUTHENTICATION_STARTED = exports.VALIDATE_ROUTE_AUTHENTICATION_STARTED = "VALIDATE_ROUTE_AUTHENTICATION_STARTED";
var VALIDATE_ROUTE_AUTHENTICATION_COMPLETED = exports.VALIDATE_ROUTE_AUTHENTICATION_COMPLETED = "VALIDATE_ROUTE_AUTHENTICATION_COMPLETED";
var CHANGE_AGENCY_VIEW_STARTED = exports.CHANGE_AGENCY_VIEW_STARTED = "CHANGE_AGENCY_VIEW_STARTED";
var CHANGE_AGENCY_VIEW_COMPLETED = exports.CHANGE_AGENCY_VIEW_COMPLETED = "CHANGE_AGENCY_VIEW_COMPLETED";
var REHYDRATE_SESSION_STARTED = exports.REHYDRATE_SESSION_STARTED = "REHYDRATE_SESSION_STARTED";
var REHYDRATE_SESSION_COMPLETED = exports.REHYDRATE_SESSION_COMPLETED = "REHYDRATE_SESSION_COMPLETED";
var AGENT_UNAUTHORIZED_AND_REDIRECT_STARTED = exports.AGENT_UNAUTHORIZED_AND_REDIRECT_STARTED = "AGENT_UNAUTHORIZED_AND_REDIRECT_STARTED";
var AGENT_UNAUTHORIZED_AND_REDIRECT_COMPLETED = exports.AGENT_UNAUTHORIZED_AND_REDIRECT_COMPLETED = "AGENT_UNAUTHORIZED_AND_REDIRECT_COMPLETED";
var IMPERSONATE_REDIRECT_STARTED = exports.IMPERSONATE_REDIRECT_STARTED = "IMPERSONATE_REDIRECT_STARTED";
var IMPERSONATE_REDIRECT_COMPLETED = exports.IMPERSONATE_REDIRECT_COMPLETED = "IMPERSONATE_REDIRECT_COMPLETED";
var fetchSSOSessionStarted = exports.fetchSSOSessionStarted = function fetchSSOSessionStarted() {
  return {
    type: FETCH_SSO_SESSION_STARTED
  };
};
var fetchSSOSessionSucceeded = exports.fetchSSOSessionSucceeded = function fetchSSOSessionSucceeded(data, user) {
  return {
    type: FETCH_SSO_SESSION_SUCCEEDED,
    payload: data,
    user: user
  };
};
var fetchSSOSessionFailed = exports.fetchSSOSessionFailed = function fetchSSOSessionFailed(error) {
  return {
    type: FETCH_SSO_SESSION_FAILED,
    payload: error,
    error: true
  };
};
var logoutAndRedirectStarted = exports.logoutAndRedirectStarted = function logoutAndRedirectStarted() {
  return {
    type: LOGOUT_REDIRECT_STARTED
  };
};
var logoutAndRedirectCompleted = exports.logoutAndRedirectCompleted = function logoutAndRedirectCompleted() {
  return {
    type: LOGOUT_REDIRECT_COMPLETED
  };
};
var validateRouteAuthenticationStarted = exports.validateRouteAuthenticationStarted = function validateRouteAuthenticationStarted() {
  return {
    type: VALIDATE_ROUTE_AUTHENTICATION_STARTED
  };
};
var validateRouteAuthenticationCompleted = exports.validateRouteAuthenticationCompleted = function validateRouteAuthenticationCompleted() {
  return {
    type: VALIDATE_ROUTE_AUTHENTICATION_COMPLETED
  };
};
var changeAgencyViewStarted = exports.changeAgencyViewStarted = function changeAgencyViewStarted() {
  return {
    type: CHANGE_AGENCY_VIEW_STARTED
  };
};
var changeAgencyViewCompleted = exports.changeAgencyViewCompleted = function changeAgencyViewCompleted() {
  return {
    type: CHANGE_AGENCY_VIEW_COMPLETED
  };
};
var rehydrateSessionStarted = exports.rehydrateSessionStarted = function rehydrateSessionStarted() {
  return {
    type: REHYDRATE_SESSION_STARTED
  };
};
var rehydrateSessionCompleted = exports.rehydrateSessionCompleted = function rehydrateSessionCompleted() {
  return {
    type: REHYDRATE_SESSION_COMPLETED
  };
};
var agentUnauthorizedAndRedirectStarted = exports.agentUnauthorizedAndRedirectStarted = function agentUnauthorizedAndRedirectStarted() {
  return {
    type: AGENT_UNAUTHORIZED_AND_REDIRECT_STARTED
  };
};
var agentUnauthorizedAndRedirectCompleted = exports.agentUnauthorizedAndRedirectCompleted = function agentUnauthorizedAndRedirectCompleted() {
  return {
    type: AGENT_UNAUTHORIZED_AND_REDIRECT_COMPLETED
  };
};
var impersonateRedirectStarted = exports.impersonateRedirectStarted = function impersonateRedirectStarted() {
  return {
    type: IMPERSONATE_REDIRECT_STARTED
  };
};
var impersonateRedirectCompleted = exports.impersonateRedirectCompleted = function impersonateRedirectCompleted() {
  return {
    type: IMPERSONATE_REDIRECT_COMPLETED
  };
};
var fetchSSOSession = exports.fetchSSOSession = function fetchSSOSession(user) {
  return function (dispatch) {
    var jwt = user && user.id_token;
    dispatch(fetchSSOSessionStarted());
    return ssoService.getSSOSession(jwt).then(function (response) {
      dispatch(fetchSSOSessionSucceeded(response.data, user));
    }, function (error) {
      dispatch(fetchSSOSessionFailed(error.message));
      ssoService.logoutAndRedirect(_.ssoClient.userManager, user);
    });
  };
};
var logoutAndRedirect = exports.logoutAndRedirect = function logoutAndRedirect(user) {
  var postLogoutRedirectUri = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return function (dispatch) {
    dispatch(logoutAndRedirectStarted());
    ssoService.logoutAndRedirect(_.ssoClient.userManager, user, function () {
      dispatch(logoutAndRedirectCompleted());
    }, postLogoutRedirectUri);
  };
};
var validateRouteAuthentication = exports.validateRouteAuthentication = function validateRouteAuthentication(user, redirectUrl) {
  return function (dispatch) {
    dispatch(validateRouteAuthenticationStarted());
    ssoService.validateCurrentRouteForUser(_.ssoClient.userManager, user, function () {
      dispatch(validateRouteAuthenticationCompleted());
    }, redirectUrl);
  };
};
var changeAgencyView = exports.changeAgencyView = function changeAgencyView(agencyCode) {
  return function (dispatch) {
    dispatch(changeAgencyViewStarted());
    ssoService.changeAgencyView(_.ssoClient.userManager, agencyCode, _.ssoClient.userManager.settings.client_id, function () {
      dispatch(changeAgencyViewCompleted());
    });
  };
};
var rehydrateSession = exports.rehydrateSession = function rehydrateSession(redirectRoute) {
  return function (dispatch) {
    dispatch(rehydrateSessionStarted());
    ssoService.rehydrateSession(_.ssoClient.userManager, _.ssoClient.userManager.settings.client_id, function () {
      dispatch(rehydrateSessionCompleted());
    }, redirectRoute);
  };
};
var agentUnauthorizedAndRedirect = exports.agentUnauthorizedAndRedirect = function agentUnauthorizedAndRedirect(applicationId) {
  return function (dispatch) {
    dispatch(agentUnauthorizedAndRedirectStarted());
    ssoService.agentUnauthorizedAndRedirect(_.ssoClient.userManager, applicationId, function () {
      dispatch(agentUnauthorizedAndRedirectCompleted());
    });
  };
};
var impersonateAgentRedirect = exports.impersonateAgentRedirect = function impersonateAgentRedirect(applicationId, userId, redirectUrl) {
  return function (dispatch) {
    dispatch(impersonateRedirectStarted());
    ssoService.impersonateAgentRedirect(_.ssoClient.userManager, applicationId, userId, function () {
      dispatch(impersonateRedirectCompleted());
    }, redirectUrl);
  };
};